import Cookies from 'js-cookie';
import moment from 'moment';

export function delayToCookies(seconds: number = 60, name: string): void {
  const nowPlusTime = moment().add(seconds, 'seconds');
  Cookies.set(name, nowPlusTime);
}
